<template>
  <main class="success">
    <section class="section">
      <div class="row align-center">
        <h1 class="success-title">Seu boleto está sendo emitido...</h1>
      </div>
      <div class="row align-center">
        <font-awesome-icon class="success-icon" :icon="'spinner'" spin />
      </div>
    </section>
  </main>
</template>

<script>
import Register from '../../services/register';
import Payment from '../../services/payment';

const register = new Register();
const payment = new Payment();

export default {
  name: 'PaymentBillet',
  data() {
    return {
      programId: this.$route.params.programId,
      items: JSON.parse(sessionStorage.getItem('register')),
      data: null,
      clientId: sessionStorage.getItem('clientId')
    };
  },
  mounted() {
    if (this.clientId) {
      this.programPayment();
    } else {
      this.programRegister();
    }
  },
  methods: {
    concatJson(obj1, obj2) {
      const obj = obj1;
      Object.keys(obj2).forEach(key => {
        obj[key] = obj2[key];
      });

      return obj;
    },
    programRegister() {
      this.$root.$emit('button-loading', true);

      this.data = this.concatJson(this.items, {
        id: this.clientId,
        einstein: sessionStorage.einstein || 0,
        telemedicina_sharecare_individual: sessionStorage.telemedicina_sharecare_individual || 0,
        telemedicina_sharecare_familiar: sessionStorage.telemedicina_sharecare_familiar || 0,
        omt_sharecare: sessionStorage.omt_sharecare || 0
      });

      register
        .doRegister(this.programId, this.data)
        .then(res => {
          sessionStorage.setItem('clientId', res.data.data.id);
          this.clientId = sessionStorage.getItem('clientId');
          this.programPayment();
        })
        .catch(err => {
          this.$root.$emit('button-loading', false);
          this.$toaster.error(err.response.data.error.message);
          this.$router.push({
            name: 'register'
          });
        });
    },
    programPayment() {
      this.data = this.concatJson(this.items, {
        id: this.clientId,
        type: 'bank_slip',
        einstein: sessionStorage.einstein || 0,
        telemedicina_sharecare_individual: sessionStorage.telemedicina_sharecare_individual || 0,
        telemedicina_sharecare_familiar: sessionStorage.telemedicina_sharecare_familiar || 0,
        omt_sharecare: sessionStorage.omt_sharecare || 0,
        renewal: sessionStorage.renewal === '1'
      });

      if (sessionStorage.utm_source) {
        this.data.utm_source = sessionStorage.utm_source;
      }

      if (sessionStorage.xtra) {
        this.data.xtra = sessionStorage.xtra;
      }

      payment
        .doPayment(this.programId, this.data)
        .then(res => {
          this.$root.$emit('button-loading', false);
          sessionStorage.clear();
          sessionStorage.setItem('bankslipUrl', res.data.data.bank_slip);
          sessionStorage.setItem('paid', res.data.message);
          this.$router.push({
            name: 'sucesso-boleto'
          });
        })
        .catch(err => {
          this.$root.$emit('button-loading', false);
          if (err.response.data.error.code === 'validation_failed') {
            this.$toaster.error('Erro de validação, tente novamente.');
            this.$router.push({
              name: 'selecionar-pagamento',
              params: {
                userId: this.programId
              }
            });
          } else {
            this.$toaster.error(err.response.data.error.message);
          }
        });
    }
  }
};
</script>
